'use strict';/* global define, console */define('modules/integrations/directives/integration-edit/controller',['require','exports','module'],function(require,exports,module){'use strict';// @ngInject
controller.$inject = ["$scope", "$state", "$stateParams", "Integrations", "Auth", "UserImports", "Toaster", "Modals", "_", "ng", "INTEGRATIONS"];
function controller($scope,$state,$stateParams,Integrations,Auth,UserImports,Toaster,Modals,_,ng,INTEGRATIONS){// jshint validthis:true
// jshint latedef:false
var ctrl=this;ctrl._initialConfig={};ctrl.integration=$scope.integration;ctrl.imports=$scope.imports;ctrl.type=$scope.type;ctrl.integrationConfigs=INTEGRATIONS;ctrl.params=$stateParams;ctrl.back=back;ctrl.config=_initConfig($scope.integration);ctrl._createConfig=_createConfig;ctrl._saveConfig=_saveConfig;ctrl.configImport=configImport;ctrl.ftpProtocols=[{label:'FTP',value:'ftp'},{label:'FTPS',value:'ftps'},{label:'SFTP',value:'sftp'}];if(ctrl.params.error!==undefined){_handleError(ctrl.params.error);}if(ctrl.type==='slack'){_getAddToSlackUrl();}// ---
/**
     * Return back to the integrations section
     */function back(){$state.go('app.admin.integrations.list',{},{reload:true});}/**
     * Cofigure the integration
     *
     * @param  {String} successKey - Success message key
     *
     */function configImport(successKey){if(ctrl.integration){if(!ng.equals(ctrl._initialConfig,ctrl.config)){ctrl._saveConfig(successKey);}}else{ctrl._createConfig(successKey);}}/**
     * Map the received integration config to the data model
     *
     * @param  {Object} configData - Provided configuration object
     *
     * @private
     */function _initConfig(configData){var config={autoImport:false,enabled:false};if(configData&&configData.configurations){config=ng.extend(config,configData.configurations);}ctrl._initialConfig=ng.copy(config);return config;}/**
     * Prepare and return the integration configurations
     *
     * @param  {String} integrationType - Success message key
     *
     * @return {Object}                 - Configurations
     *
     * @private
     */function _getConfigurations(integrationType){var configs={};var integration=Integrations.getByConfigId(ctrl.integrationConfigs,integrationType);integration.options.forEach(function(optionName){configs[optionName]=ctrl.config[optionName];});return configs;}/**
     * Create the integration config
     *
     * @param  {String} successKey - Success message key
     *
     * @private
     */function _createConfig(successKey){Integrations.create({name:ctrl.type,configurations:_getConfigurations(ctrl.type)}).$promise.then(function(data){ctrl.integration=ng.copy(data);ctrl.config=_initConfig(data);Toaster.success(successKey);}).catch(Modals.fail);}/**
     * Save the integration config
     *
     * @param  {String} successKey - Success message key
     *
     * @private
     */function _saveConfig(successKey){Integrations.update({id:ctrl.integration.id},{configurations:_getConfigurations(ctrl.integration.name)}).$promise.then(function(data){ctrl.config=_initConfig(data);Toaster.success(successKey);}).catch(Modals.fail);}/**
     * Get the URL for add-to-slack button
     *
     * @private
     */function _getAddToSlackUrl(){Auth.getAddToSlackUrl().then(function(response){ctrl.addToSlackUrl=response.url;}).catch(function(response){Modals.fail(response);});}/**
     * Handle error received via query parameter
     *
     * @param {String} error - Error data as a Json encoded string
     *
     * @private
     */function _handleError(error){try{var data=ng.fromJson(error);var reason={data:data};Modals.fail(reason);}catch(err){// ignore the error if it is not a valid json
}}}module.exports=controller;});
